import React from 'react';
import './socialmediastyles.css';
import { WhatsApp, Language, Instagram, Facebook, YouTube, HeadsetMic, ArrowForwardIos } from '@mui/icons-material';
import LogoInformezzVertical from '../../imagens/logoInformezzAzul.svg';

const contacts = [
  {
    id: 'whatsapp-comercial',
    href: 'https://wa.me/5546991107619',
    icon: <WhatsApp className="contact-icon" />,
    iconBg: 'icon-bg--whatsapp',
    label: 'WhatsApp Comercial',
    sublabel: 'Tire dúvidas sobre planos e vendas',
  },
  {
    id: 'suporte-tecnico',
    href: 'https://wa.me/554632250131',
    icon: <HeadsetMic className="contact-icon" />,
    iconBg: 'icon-bg--suporte',
    label: 'Suporte Técnico',
    sublabel: 'Atendimento e suporte ao sistema',
  },
  {
    id: 'site',
    href: 'https://www.informezz.com.br',
    icon: <Language className="contact-icon" />,
    iconBg: 'icon-bg--site',
    label: 'Site',
    sublabel: 'www.informezz.com.br',
  },
  {
    id: 'instagram',
    href: 'https://www.instagram.com/informezz/',
    icon: <Instagram className="contact-icon" />,
    iconBg: 'icon-bg--instagram',
    label: 'Instagram',
    sublabel: '@informezz',
  },
  {
    id: 'facebook',
    href: 'https://www.facebook.com/informezzoficial/',
    icon: <Facebook className="contact-icon" />,
    iconBg: 'icon-bg--facebook',
    label: 'Facebook',
    sublabel: 'facebook.com/informezzoficial',
  },
  {
    id: 'youtube',
    href: 'https://www.youtube.com/@informezz',
    icon: <YouTube className="contact-icon" />,
    iconBg: 'icon-bg--youtube',
    label: 'YouTube',
    sublabel: '@informezz',
  },
];

const SocialMedia = () => {
  return (
    <div className="sm-page">
      {/* Background decorativo */}
      <div className="sm-bg-decoration" aria-hidden="true">
        <div className="sm-bg-blob sm-bg-blob--1" />
        <div className="sm-bg-blob sm-bg-blob--2" />
      </div>

      <div className="sm-card">
        {/* Logo */}
        <div className="sm-logo-wrapper">
          <img src={LogoInformezzVertical} alt="Informezz" className="sm-logo" />
        </div>

        {/* Header */}
        <div className="sm-header">
          <h1 className="sm-title">Entre em contato</h1>
          <p className="sm-subtitle">Estamos prontos para atender</p>
        </div>

        {/* Botões de contato */}
        <div className="sm-contacts">
          {contacts.map((c) => (
            <a
              key={c.id}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              className="sm-contact-item"
            >
              <span className={`sm-icon-wrap ${c.iconBg}`}>
                {c.icon}
              </span>
              <span className="sm-contact-text">
                <span className="sm-contact-label">{c.label}</span>
                <span className="sm-contact-sublabel">{c.sublabel}</span>
              </span>
              <ArrowForwardIos className="sm-arrow" />
            </a>
          ))}
        </div>

        {/* Rodapé da card */}
        <p className="sm-footer-text">© {new Date().getFullYear()} Informezz · Todos os direitos reservados</p>
      </div>
    </div>
  );
};

export default SocialMedia;
